import { doc, serverTimestamp } from "firebase/firestore";
import { useState } from "react";
import { db } from "app/init"
import { addReferals, getDocDetails, showErrMsg, showSuccssMsg, updateDocument } from "app/utils/utils";
import { collectionKeys } from "core/helper/const";
import { Box, Grid, styled, TextField, Button, Typography, Stack, Paper } from "@mui/material";
import { Span } from "app/components/Typography";
import { Breadcrumb, SimpleCard } from "app/components";
import { ROUTES } from "app/utils/constant";
import ErrorMsg from "app/components/common/validation-error";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import StatusSwitch from "app/components/common/switch";

const TextFieldInput = styled(TextField)(() => ({
    width: "100%",
    marginBottom: "5px"
}));

const Container = styled("div")(({ theme }) => ({
    margin: "30px",
    [theme.breakpoints.down("sm")]: { margin: "16px" },
    "& .breadcrumb": {
        marginBottom: "30px",
        [theme.breakpoints.down("sm")]: { marginBottom: "16px" }
    }
}));

const Title = styled("span")(() => ({
    fontSize: "0.9rem",
    fontWeight: "600",
    textTransform: "capitalize",
    display: "block"
}));

const validationSchema = Yup.object().shape({
    team: Yup.string().label("Team").required(),
    membername: Yup.string().label("MemberName").required(),
    referealId: Yup.string().label("Referal Id").required()
})

const GenerateReferal = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [generatedLink, setGeneratedLink] = useState("");
    const [loading, setLoading] = useState(false);
    const [copySuccess, setCopySuccess] = useState("");
    const [isMounted, setMounted] = useState(false);
    const [isVisibility, setIsVisibility] = useState();
    const [allData, setAllData] = useState([]);

    console.log(allData)

    const { handleSubmit, setValue, reset, register, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    })

    const onGenerate = async (values) => {
        id ? updateReferal(collectionKeys.REFERAL, id, values) : handleGenerate(values)
    }

    const handleGenerate = async (values) => {
        if (!values?.team || !values?.referealId || !values?.membername) return;

        const team = values.team.trim();
        const referealId = values.referealId.trim();
        const membername = values.membername.trim();

        const payload = {
            team,
            membername,
            referealId,
            createdAt: serverTimestamp(),
            views: 0,
            status: true,
            utm_source: "",
        };

        setLoading(true);
        try {
            const response = await addReferals(db, collectionKeys.REFERAL, payload);
            // console.log(response, "sd")
            if (response) {
                setTimeout(() => {
                    showSuccssMsg(response?.msg || "Referal Id Has been created");
                }, 500);
                navigate("/referals")
                reset();
                setLoading(false);
            }
        } catch (err) {
            showErrMsg(err.message || "RefId Cannot Created")
            console.error("Error saving to Firestore:", err);
            setLoading(false);
        }
    };

    const handleIsChangeVisibility = (event) => {
        const { checked } = event.target;
        setIsVisibility(checked)
        setValue("status", checked, { shouldValidate: true })
    };

    const updateReferal = async (referal, id, values) => {
        try {
            setLoading(true);
            const response = await updateDocument(referal, id, values);
            if (response) {
                setTimeout(() => {
                    showSuccssMsg(response?.msg || "Referal Id Has been Updated");
                }, 500);
                reset();
                setLoading(false);
                navigate("/referals")
            }
        } catch (error) {
            console.log("first", error)
        }
    }

    const handleCopy = () => {
        if (!generatedLink) return;

        navigator.clipboard.writeText(generatedLink).then(() => {
            setCopySuccess("Copied!");
            setTimeout(() => setCopySuccess(""), 2000);
        });
    };

    useEffect(() => {
        setMounted(true);
        return () => {
            setMounted(false);
        };
    }, []);

    const loadReferalsDetails = async () => {
        try {
            const response = await getDocDetails(collectionKeys.REFERAL, id);
            if (response) {
                const fields = [
                    "membername",
                    "referealId",
                    "team",
                    "status"
                ]
                fields.forEach((field) => {
                    setValue(field, response?.[field], {
                        shouldValidate: true
                    })
                })
                setIsVisibility(response.status);
                setAllData(response)
            }
        } catch (error) {
            console.log("Error", error)
        }
    }

    useEffect(() => {
        if (isMounted) {
            if (id) {
                loadReferalsDetails();
            }
        }
    }, [id, isMounted])
    return (
        <Container>
            <Box className="breadcrumb">
                <Breadcrumb
                    routeSegments={[{ name: "Referals", path: ROUTES.REFERALS }, { name: id ? "View Referals" : "Generate Referals" }]}
                    isNeed={false}
                />
            </Box>
            <SimpleCard>
                <form onSubmit={handleSubmit(onGenerate)}>
                    {id ? <>
                        <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
                            <Grid container spacing={4}>
                                {/* Member Name */}
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" fontWeight={600} mb={1}>
                                        Member Name
                                    </Typography>
                                    <Typography variant="body1">{allData?.membername}</Typography>
                                </Grid>

                                {/* Team Name */}
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" fontWeight={600} mb={1}>
                                        Team Name
                                    </Typography>
                                    <Typography variant="body1">{allData?.team}</Typography>
                                </Grid>

                                {/* Referral ID */}
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" fontWeight={600} mb={1}>
                                        Referral ID
                                    </Typography>
                                    <Typography variant="body1">{allData?.referealId}</Typography>
                                </Grid>

                                {/* Visible Toggle */}
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" fontWeight={600} mb={1}>
                                        Visible
                                    </Typography>
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                        <Typography>Hide</Typography>
                                        <StatusSwitch
                                            handleChange={handleIsChangeVisibility}
                                            checked={isVisibility}
                                        />
                                        <Typography>Show</Typography>
                                    </Stack>
                                    <ErrorMsg msg={errors?.status?.message} />
                                </Grid>
                            </Grid>
                        </Paper>
                    </> : <>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <Grid container spacing={2}>
                                    <Grid item md={12} xs={12}>
                                        <Title>Team Name: </Title>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextFieldInput {...register("team")} type="text" placeholder="Enter Team Name" />
                                        <ErrorMsg msg={errors?.team?.message} />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <Grid container spacing={2}>
                                    <Grid item md={12} xs={12}>
                                        <Title>Referal Id: </Title>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextFieldInput {...register("referealId")} type="text" placeholder="Enter refereal id" />
                                        <ErrorMsg msg={errors?.referealId?.message} />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <Grid container spacing={2}>
                                    <Grid item md={12} xs={12}>
                                        <Title>Member Name: </Title>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextFieldInput {...register("membername")} type="text" placeholder="Enter Member Name" />
                                        <ErrorMsg msg={errors?.membername?.message} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>}
                    <Button
                        sx={{
                            marginTop: "10px"
                        }}
                        color="primary"
                        variant="contained"
                        type="submit"
                        disabled={loading}
                    >
                        <Span sx={{ textTransform: "capitalize" }}>{id ? "Update" : "Generate"}</Span>
                    </Button>
                </form>
            </SimpleCard>
            {
                generatedLink && (
                    <div className="mt-4">
                        <p className="font-medium">Referral Link:</p>
                        <code className="bg-gray-100 p-2 rounded block">{generatedLink}</code>
                        <button
                            onClick={handleCopy}
                            className="mt-2 bg-green-500 text-white px-4 py-2 rounded"
                        >
                            {copySuccess || "Copy to Clipboard"}
                        </button>
                    </div>
                )
            }
        </Container >
    )
}

export default GenerateReferal;